import { useEffect } from "react";
import { toast } from "react-toastify";
import { ENDPOINT, NOTIFICATION } from "./Service";
import fallbackMessages from "./dummyNotification.json";

// Generates a random interval between 1 to 2 minutes
const getRandomInterval = () => {
	const min = 13_000; // 13 seconds in ms
	const max = 18_000; // 18 seconds in ms
	return Math.floor(Math.random() * (max - min + 1)) + min;
  };

const fetchMessageFromAPI = async () => {
	try {
		const response = await fetch(`${ENDPOINT}${NOTIFICATION}`);
		const data = await response.json();
		if (data && data?.data) {
			return data?.data;
		} else {
			throw new Error("No message data available");
		}
	} catch (error) {
		console.error("Error fetching notification:", error);
		return null;
	}
};

const generateToast = (message, countryId) => {
	toast.dismiss();

	toast(
		<div style={{ display: "flex", alignItems: "center" }}>
			{countryId ? (
				<>
					{countryId === 1 && <img src="/assets/images/usa.png" width={40} alt="USA" />}
					{countryId === 2 && <img src="/assets/images/canada.png" width={40} alt="Canada" />}
					{countryId === 3 && <img src="/assets/images/aus.png" width={40} alt="Australia" />}
					{countryId === 4 && <img src="/assets/images/nzl.png" width={40} alt="New Zealand" />}
					{countryId === 10 && <img src="/assets/images/uk.png" width={40} alt="UK" />}
				</>
			) : (
				<img src="/assets/images/usa.png" width={40} alt="Default Country" />
			)}
			<span className="ms-3">{message}</span>
		</div>,
		{ autoClose: 3000 }
	);
};

const useRandomToasts = () => {
	useEffect(() => {
		let timeoutId;
		let isTabActive = true;
		let lastScheduledInterval = getRandomInterval();

		const fetchAndSchedule = async () => {
			if (!isTabActive) return;

			console.log("Fetching new notification...");

			const apiMessage = await fetchMessageFromAPI();
			if (apiMessage) {
				generateToast(apiMessage?.message, apiMessage?.country);
			} else {
				const randomMessage = fallbackMessages[Math.floor(Math.random() * fallbackMessages.length)];
				generateToast(randomMessage?.message, randomMessage?.country);
			}

			lastScheduledInterval = getRandomInterval();
			console.log(`Next notification scheduled in: ${lastScheduledInterval / 1000} seconds`);
			timeoutId = setTimeout(fetchAndSchedule, lastScheduledInterval);
		};

		const handleVisibilityChange = () => {
			isTabActive = !document.hidden;

			if (isTabActive) {
				console.log("Tab is active again. Rescheduling notification...");
				timeoutId = setTimeout(fetchAndSchedule, lastScheduledInterval);
			} else {
				console.log("Tab is inactive. Pausing notification...");
				clearTimeout(timeoutId);
			}
		};

		document.addEventListener("visibilitychange", handleVisibilityChange);

		const initialDelay = getRandomInterval();
		console.log(`First notification will appear after: ${initialDelay / 1000} seconds`);
		timeoutId = setTimeout(fetchAndSchedule, initialDelay);

		return () => {
			clearTimeout(timeoutId);
			document.removeEventListener("visibilitychange", handleVisibilityChange);
		};
	}, []);
};

export default useRandomToasts;
